package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TheaterComedyW500Rounded: ImageVector
    get() {
        if (_theaterComedyW500Rounded != null) {
            return _theaterComedyW500Rounded!!
        }
        _theaterComedyW500Rounded = Builder(name = "TheaterComedyW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(760.0f, 294.5f)
                quadToRelative(17.81f, 0.0f, 29.86f, -12.05f)
                reflectiveQuadToRelative(12.05f, -29.86f)
                quadToRelative(0.0f, -17.71f, -12.05f, -29.7f)
                quadToRelative(-12.05f, -11.98f, -29.86f, -11.98f)
                reflectiveQuadToRelative(-29.86f, 11.99f)
                quadToRelative(-12.05f, 11.98f, -12.05f, 29.69f)
                reflectiveQuadToRelative(12.05f, 29.81f)
                quadToRelative(12.05f, 12.1f, 29.86f, 12.1f)
                close()
                moveTo(600.0f, 294.5f)
                quadToRelative(17.81f, 0.0f, 29.86f, -12.05f)
                reflectiveQuadToRelative(12.05f, -29.86f)
                quadToRelative(0.0f, -17.71f, -12.09f, -29.7f)
                quadToRelative(-12.1f, -11.98f, -29.82f, -11.98f)
                reflectiveQuadToRelative(-29.82f, 11.99f)
                quadToRelative(-12.09f, 11.98f, -12.09f, 29.69f)
                reflectiveQuadToRelative(12.05f, 29.81f)
                quadToRelative(12.05f, 12.1f, 29.86f, 12.1f)
                close()
                moveTo(625.7f, 363.61f)
                quadToRelative(-26.03f, 11.02f, -38.5f, 36.06f)
                quadToRelative(-5.72f, 10.24f, 2.02f, 19.58f)
                quadToRelative(7.74f, 9.34f, 20.93f, 9.34f)
                horizontalLineToRelative(139.7f)
                quadToRelative(13.19f, 0.0f, 20.93f, -9.34f)
                reflectiveQuadToRelative(2.02f, -19.58f)
                quadToRelative(-12.47f, -25.04f, -38.5f, -36.06f)
                quadToRelative(-26.02f, -11.02f, -54.3f, -11.02f)
                quadToRelative(-28.28f, 0.0f, -54.3f, 11.02f)
                close()
                moveTo(104.86f, 822.49f)
                quadTo(32.59f, 750.4f, 32.59f, 647.41f)
                lineTo(32.59f, 451.0f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                quadTo(85.8f, 360.0f, 123.59f, 360.0f)
                horizontalLineToRelative(312.82f)
                quadToRelative(37.79f, 0.0f, 64.39f, 26.61f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.39f)
                verticalLineToRelative(196.41f)
                quadToRelative(0.0f, 102.99f, -72.27f, 175.08f)
                quadToRelative(-72.27f, 72.1f, -175.14f, 72.1f)
                quadToRelative(-102.87f, 0.0f, -175.14f, -72.1f)
                close()
                moveTo(393.0f, 760.41f)
                quadToRelative(47.0f, -47.0f, 47.0f, -113.0f)
                verticalLineToRelative(-200.0f)
                lineTo(120.0f, 447.41f)
                verticalLineToRelative(200.0f)
                quadToRelative(0.0f, 66.0f, 47.0f, 113.0f)
                reflectiveQuadToRelative(113.0f, 47.0f)
                quadToRelative(66.0f, 0.0f, 113.0f, -47.0f)
                close()
                moveTo(927.41f, 156.41f)
                verticalLineToRelative(196.18f)
                quadToRelative(0.0f, 104.39f, -72.27f, 176.02f)
                quadToRelative(-72.27f, 71.63f, -175.9f, 71.63f)
                quadToRelative(-15.09f, 0.0f, -29.9f, -1.68f)
                quadToRelative(-14.81f, -1.68f, -29.17f, -5.89f)
                quadToRelative(-17.67f, -5.24f, -25.87f, -21.07f)
                quadToRelative(-8.19f, -15.84f, -2.95f, -33.99f)
                quadToRelative(5.0f, -17.68f, 20.72f, -25.53f)
                quadToRelative(15.71f, -7.86f, 32.91f, -4.06f)
                quadToRelative(8.37f, 2.28f, 15.98f, 3.43f)
                quadToRelative(7.61f, 1.14f, 15.97f, 1.14f)
                quadToRelative(67.44f, -0.24f, 115.25f, -45.93f)
                quadTo(840.0f, 420.98f, 840.0f, 352.59f)
                verticalLineToRelative(-200.0f)
                lineTo(520.0f, 152.59f)
                verticalLineToRelative(103.82f)
                quadToRelative(0.0f, 18.53f, -12.53f, 31.06f)
                quadTo(494.94f, 300.0f, 476.41f, 300.0f)
                quadToRelative(-18.43f, 0.0f, -31.13f, -12.7f)
                quadToRelative(-12.69f, -12.69f, -12.69f, -31.13f)
                verticalLineToRelative(-99.76f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                quadToRelative(26.6f, -26.61f, 64.39f, -26.61f)
                horizontalLineToRelative(312.82f)
                quadToRelative(37.79f, 0.0f, 64.39f, 26.61f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.39f)
                close()
                moveTo(200.0f, 589.09f)
                quadToRelative(17.81f, 0.0f, 29.86f, -11.99f)
                quadToRelative(12.05f, -11.98f, 12.05f, -29.69f)
                reflectiveQuadToRelative(-12.05f, -29.81f)
                quadToRelative(-12.05f, -12.1f, -29.86f, -12.1f)
                reflectiveQuadToRelative(-29.86f, 12.05f)
                quadToRelative(-12.05f, 12.05f, -12.05f, 29.86f)
                quadToRelative(0.0f, 17.71f, 12.05f, 29.7f)
                quadToRelative(12.05f, 11.98f, 29.86f, 11.98f)
                close()
                moveTo(389.82f, 577.1f)
                quadToRelative(12.09f, -11.98f, 12.09f, -29.69f)
                reflectiveQuadToRelative(-12.05f, -29.81f)
                quadToRelative(-12.05f, -12.1f, -29.86f, -12.1f)
                reflectiveQuadToRelative(-29.86f, 12.05f)
                quadToRelative(-12.05f, 12.05f, -12.05f, 29.86f)
                quadToRelative(0.0f, 17.71f, 12.09f, 29.7f)
                quadToRelative(12.1f, 11.98f, 29.82f, 11.98f)
                reflectiveQuadToRelative(29.82f, -11.99f)
                close()
                moveTo(332.33f, 712.76f)
                quadToRelative(24.82f, -10.66f, 38.71f, -33.91f)
                quadToRelative(5.72f, -11.0f, -0.76f, -21.22f)
                quadToRelative(-6.48f, -10.22f, -18.91f, -10.22f)
                lineTo(208.63f, 647.41f)
                quadToRelative(-12.43f, 0.0f, -18.91f, 10.22f)
                reflectiveQuadToRelative(-0.76f, 21.22f)
                quadToRelative(13.89f, 23.25f, 38.71f, 33.91f)
                quadToRelative(24.81f, 10.65f, 52.33f, 10.65f)
                reflectiveQuadToRelative(52.33f, -10.65f)
                close()
                moveTo(280.0f, 627.41f)
                close()
                moveTo(668.09f, 332.59f)
                close()
            }
        }
        .build()
        return _theaterComedyW500Rounded!!
    }

private var _theaterComedyW500Rounded: ImageVector? = null
